"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionCard = void 0;
const core_api_1 = require("@ikegps/core-api");
const is_missing_true_size_1 = require("../../components/red.dot/is.missing.true.size");
const collection_title_1 = require("../../components/collection/collection.title");
const theme_1 = require("../../components/theme");
const dom_1 = require("../../dom");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const highlighter_1 = require("../../services/util/highlighter");
const page_state_1 = require("../../state/page.state");
const tag_sort_state_1 = require("../../state/tag.sort.state");
const tag_card_checkbox_1 = require("../tag.card.checkbox/tag.card.checkbox");
const collection_card_style_1 = require("./collection.card.style");
(0, theme_1.addStyles)(collection_card_style_1.Style);
exports.CollectionCard = {
    view(state, tag, collectionSummary) {
        const hasLocation = collectionSummary.location != null;
        const attributes = exports.CollectionCard.getAttributes(state, collectionSummary, hasLocation);
        const titleText = collectionSummary.title || collectionSummary.subtitle;
        const title = hasLocation ? titleText : `${titleText} (${(0, index_1.Translate)(index_1.T.NO_LOCATION)})`;
        const isSubtitle = !collectionSummary.title && !!collectionSummary.subtitle;
        const selectedState = {
            isSelected: () => page_state_1.CurrentState.Tag.isCollectionSelected(tag.objectId, collectionSummary.uuid),
            setSelected: (selected) => page_state_1.CurrentState.Tag.selectCollection(tag.objectId, collectionSummary.uuid, selected),
        };
        const showRedDot = (0, is_missing_true_size_1.getShowRedDot)(collectionSummary);
        const children = [
            tag_card_checkbox_1.TagCardCheckbox.view(state, selectedState, tag, null, services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) ? collectionSummary.mapMarkerColor : null, showRedDot),
            (0, mithril_1.m)('span', {
                className: isSubtitle ? `${collection_card_style_1.CSS.link} ${collection_card_style_1.CSS.isSubtitle}` : collection_card_style_1.CSS.link,
                title,
            }, exports.CollectionCard.viewTitle(collectionSummary)),
        ];
        let sortValue = tag_sort_state_1.TagSortState.getCollectionDisplayValue(collectionSummary);
        if (sortValue != null) {
            if (sortValue instanceof Date) {
                sortValue = services_1.Services.DateTime.formatDateTime(sortValue);
            }
            children.push((0, mithril_1.m)('div', { className: collection_card_style_1.CSS.info, title: (0, index_1.Translate)(tag_sort_state_1.TagSortState.option.title) }, sortValue));
        }
        return (0, mithril_1.m)('div', attributes, children);
    },
    getAttributes(state, collectionSummary, hasLocation) {
        const isHovered = page_state_1.CurrentState.hoverId === collectionSummary.revision ? collection_card_style_1.CSS.isHovered : '';
        const isInspected = page_state_1.CurrentState.inspectedCollectionRevision === collectionSummary.revision ? collection_card_style_1.CSS.isInspected : '';
        const isNotLocated = hasLocation ? '' : collection_card_style_1.CSS.noLocation;
        return {
            key: 'cc-' + collectionSummary.revision,
            className: `${collection_card_style_1.CSS.container} ${isHovered} ${isInspected} ${isNotLocated}`,
            [dom_1.DRAGON_ID]: collectionSummary.revision,
            [dom_1.DRAGON_TYPE]: dom_1.DragonDomTypes.COLLECTION,
            onclick: () => state.map.zoomToCollection(collectionSummary.revision),
        };
    },
    viewTitle(collectionSummary) {
        const title = collectionSummary.title || collectionSummary.subtitle;
        if (title == null) {
            return collection_title_1.CollectionTitle.view(collectionSummary.title);
        }
        if (services_1.Services.Search.filterState.hasFilter()) {
            return highlighter_1.Highlighter.highlight(title, services_1.Services.Search.filterState.filter).parts.map((part) => (0, mithril_1.m)('span', { className: part.highlighted ? collection_card_style_1.CSS.filterMatch : null }, part.content));
        }
        return title;
    },
};
//# sourceMappingURL=collection.card.js.map